import React from 'react'

import {createLargeSvgIcon} from './utils'
import {css} from '../theme/css'

const root = css`
  && {
    filter: none;
  }
`

export default createLargeSvgIcon(
  <>
    <rect width="40" height="40" rx="12" fill="#343333" />
    <path
      d="M26.0558 18.2673C25.9349 16.6613 25.2231 15.3825 23.9959 14.5677C22.9708 13.8876 21.589 13.5407 19.8918 13.5407H19.7015V13.5347H18.04V10.9236H23.3852C24.1862 10.9236 24.8405 10.3169 24.8405 9.5417C24.8405 8.76649 24.1783 8.11816 23.3852 8.11816H16.5868C15.7838 8.11816 15.1315 8.76847 15.1315 9.57342V14.9008C15.1315 15.7037 15.7818 16.356 16.5868 16.356H19.9533C22.2055 16.356 22.9233 17.389 22.9233 18.4556C22.9233 19.5223 22.3562 21.1877 19.9909 21.1877C18.0361 21.1877 16.8683 19.8653 16.6264 19.6492C15.9028 19.0008 15.1731 19.0464 14.6894 19.4727C14.0728 20.0179 14.1481 20.7812 14.5209 21.3483C14.965 22.0204 16.6938 24.1081 19.989 24.1081C21.8606 24.1081 23.5141 23.436 24.6442 22.2187C25.6474 21.1361 26.1609 19.6967 26.0538 18.2692"
      fill="white"
    />
    <path
      d="M8.37339 21.423C7.33753 21.7528 6.75304 22.8682 7.22322 23.8483C8.23421 25.9558 9.75631 27.79 11.6635 29.1764C14.1041 30.9503 17.0475 31.8982 20.0646 31.8816C23.0817 31.8651 26.0145 30.8851 28.4355 29.0844C30.2987 27.6986 31.7837 25.8825 32.7718 23.8042C33.2638 22.7694 32.6344 21.6 31.5389 21.2644C30.5914 20.9741 29.6015 21.5173 29.1512 22.4C28.4355 23.8031 27.4032 25.0306 26.1266 25.9801C24.3673 27.2887 22.2359 28.0009 20.0434 28.0129C17.8508 28.0249 15.7118 27.3361 13.9383 26.0469C12.6802 25.1325 11.6528 23.9499 10.9244 22.594C10.4276 21.6694 9.37352 21.1046 8.37339 21.423Z"
      fill="#85AF5A"
    />
  </>,
  'FivePost',
  {className: root, viewBox: '0 0 40 40'},
)
